<template>
  <div class="common-box">
    <div class="bd">
      <a @click="setUserDistributor" class="btn">设置分销员</a>
    </div>
  </div>
</template>

<script>
import { setUserDistributor } from './query.gql'

export default {
  name: 'toolDebug',
  data() {
    return {}
  },
  components: {
  },
  async mounted() {
    await this.weixinAuth()
  },
  methods: {
    setUserDistributor() {
      const self = this
      console.log('setUserDistributor...')
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '请求中'
      })

      self.$apollo.mutate({
        mutation: setUserDistributor
      }).then(res => {
        console.log(res.data)
        self.$toast.success('操作成功')
      }).catch(err => {
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '操作失败')
      })
    }
  }
}
</script>

<style lang="scss">
html,body,#app {
  height: 100%;
}
.common-box {
  position: relative;
  width: 100%;
  height: 100%;

  .bd {
    padding: 10%;
    .btn{
      font-size: 16px;
      background: #ff7639;
      padding: 4vw;
      color: #fff;
    }
  }
}
</style>
